import { useMemo } from "react";

const ENV_DEVELOPMENT = "development";
const ENV_STAGING = "staging";
const ENV_PRODUCTION = "production";

/**
 * Hook to determine current execution environment (production, staging, development).
 * Staging is inferred from hostnames matching `staging*.yoast.com`.
 * Production is the default unless NODE_ENV explicitly equals development.
 *
 * @returns {{env:string,isProduction:boolean,isDevelopment:boolean,isStaging:boolean}} Environment info.
 */
export function useEnvironment() {
	const hostname = window.location.hostname;
	const isStaging = hostname.startsWith( "staging" ) && hostname.endsWith( ".yoast.com" );
	const isDevelopment = process.env.NODE_ENV === "development";
	const isProduction = ! isDevelopment;
	const isTest = process.env.NODE_ENV === "test";

	// Resolve environment without nested ternary for readability / lint compliance.
	let env = ENV_PRODUCTION;
	if ( isDevelopment ) {
		env = ENV_DEVELOPMENT;
	} else if ( isStaging ) {
		env = ENV_STAGING;
	} else if ( isTest ) {
		env = "test";
	}

	return useMemo( () => ( {
		env,
		isProduction,
		isDevelopment,
		isStaging,
		isTest,
	} ), [ env, isProduction, isDevelopment, isStaging, isTest ] );
}
